// Run below command to force prod on local.
// REACT_APP_FORCE_PROD=true npm run start

export const IS_DEVELOPMENT = (process.env.NODE_ENV === "development") && process.env.REACT_APP_FORCE_PROD !== "true";

export const IS_TEST_CLOUD_FN = (process.env.NODE_ENV === "development") && process.env.REACT_APP_TEST_CLOUD_FN === "true";

export const PLACEHOLDER_IMAGE = "https://images.weserv.nl/?url=https://i.imgur.com/fSgnUKW.jpeg&w=512&h=512&fit=cover";